<template>
    <div class="relative flex xl:flex-row-reverse flex-col w-full z-10 itmes items-end xl:items-start justify-center mx-auto font-fira scrolltender">
        <img class="md:w-1/3 w-full block md:absolute relative xl:relative pin-r pin-t z-0" src="../assets/infoblokk_kedv_final_felso_cmyk_ESZA.jpg"
             alt="">
        <div class="infosection">
            <div class="self-center font-fira text-black flex w-full p-8 mt-8">
                <h1 class="ml-1 text-xl md:text-2xl font-hairline rotate">Infók</h1>
                <div class="-ml-4">
                    <h2 class="text-xl md:text-2xl font-normal uppercase ml-2">a VEKOP-8.3.1-16 pályázaton</h2>
                    <h2 class="md:ml-0 md:pl-8 md:pt-4 md:-mt-4 text-xl md:text-2xl font-hairline">elért <span
                            class="font-normal">sikeres eredményeinkről</span>
                    </h2>
                </div>
            </div>
            <div class="flex flex-col mt-8 leading-loose font-light px-4 mb-8 md:mx-8">
                Kedvezményezett neve: VISUALZ Webdesign & Branding Stúdió Kft. <br>
                Projekt címe: Colorization in progress<br>
                Szerződött támogatás összege: 2 967 050 Ft<br>
                Támogatás mértéke: 90%<br>
                <span class="leading-normal my-1">Projekt tartalmának bemutatása: Hazai vállalkozások számára modern, versenyképes és minőségi online és
            offline megjelenést biztosító szolgáltatást nyújtunk. A támogatás segítségével korszerű eszközparkot tudunk
            kiépíteni a partnereink igényeinek hatékony kielégítésére.</span>
                Projekt tervezett befejezési dátuma: 2018.06.30.<br>
                Projekt azonosító száma: VEKOP-8.3.1-16-2017-00080
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Tender'
}
</script>

<style lang="scss" scoped>
    .rotate {
        transform: rotate(-90deg);
    }
    .infosection {
        @media (min-width: 1200px) {
            margin-left: 180px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Tender.vue